let case_studies_slider_blocks = document.querySelectorAll('.case-studies-slider');

case_studies_slider_blocks.forEach(case_studies_slider => {

    let slider = case_studies_slider.querySelector('.case-studies-slider--slider');
    let slider_controls = case_studies_slider.querySelector('.case-studies-slider--slider_nav');

    var cs_slider = tns({
        container: slider,
        items: 1,
        slideBy: 1,
        autoplay: false,
        nav: false,
        controlsContainer: slider_controls,
        controlsText: ['<i class="customicon-arrow-left"></i>', '<i class="customicon-arrow-right"></i>'],
        navPosition: "bottom",
        loop: false,
        onIndexChanged: highlightCurrentSlide,
        onInit: function(info) {
            highlightCurrentSlide(info);
        },
        //autoHeight: true,
    });


    cs_slider.events.on('indexChanged', highlightCurrentSlide);

    function highlightCurrentSlide(info) {
        var currentIndex = info.displayIndex - 1;
        var slides = case_studies_slider.querySelectorAll('.tns-item');

        // Remove current-slide class from all slides
        slides.forEach(function(slide) {
            slide.classList.remove('current-slide');
        });

        // Add current-slide class to the current slide
        slides[currentIndex].classList.add('current-slide');
    }

});